import $ from 'jquery';
import { importModule } from 'disy';
import logger from 'cadenza/utils/logging';

export default function (repositoryItemKey, repositoryItemName) {
  importModule('share-dialog').then(function (ShareDialog) {
    const dialog = new ShareDialog(repositoryItemKey, repositoryItemName);
    const deferred = new $.Deferred();
    dialog.addEventListener('close', () => {
      dialog.remove();
      deferred.resolve();
    });
    document.body.appendChild(dialog);
    dialog.showModal();
    return deferred.promise();
  }, error => logger.error('Failed to show share dialog.', error));
}
